import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CommonModule } from "@angular/common";
import { NotFoundComponent } from "./not-found/not-found.component";
import { HomeComponent } from "./components/home/home.component";
import { ProductsComponent } from "./components/products/products.component";
import { ProductComponent } from "./components/product/product.component";
import { SearchComponent } from "./components/search/search.component";
import { CartComponent } from "./components/cart/cart.component";
import { CheckoutComponent } from "./components/checkout/checkout.component";
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { TestimonialsComponent } from "./components/testimonials/testimonials.component";
import { GalleryComponent } from "./components/gallery/gallery.component";
import { ShippingDeliveryComponent } from "./components/shipping-delivery/shipping-delivery.component";
import { PricingComponent } from "./components/pricing/pricing.component";

const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: 'about', component: AboutComponent},
  { path: 'contact', component: ContactComponent},
  { path: 'testimonials', component: TestimonialsComponent},
  { path: 'gallery', component: GalleryComponent},
  { path: 'shipping', component: ShippingDeliveryComponent},
  { path: 'pricing', component: PricingComponent},
  { path: 'search', component: SearchComponent},
  { path: 'cart', component: CartComponent},
  { path: 'checkout', component: CheckoutComponent},
  { path: 'search/:id', component: SearchComponent, data: { title: 'Search' }},
  { path: 'products/:category/page/:page', component: ProductsComponent, data: { title: 'Products' } },
  { path: 'products', redirectTo: 'products/all/page/1' },
  { path: 'category/:category/product/:id', component: ProductComponent},
  { path: "**", redirectTo: "/", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
